import type { Action } from './action-types';
import * as types from './action-types';
import ChipInput from '../../components/filter/filters/chip-input/ChipInput';

const initialState = {
  fetchingReports: true,
  reports: [],
  fetchingReportFields: false,
  fields: [],
  filters: [],
  reportFilters: [],
  schedule: [],
  businessReport: {},
  recipients: {
    to: [],
    cc: [],
    bcc: []
  },
  selectedFields: [],
  reportName: '',
  reportDescription: '',
  exportingReport: false,
  exportingCustomisedReport: false,
  savingReport: false,
  deletingReport: false,
  isScheduleUpdated: false,
  dynamicFilters: []
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    /*************************Fetch Reports action states START ***************************/
    case `${types.FETCH_REPORTS}_PENDING`:
      return Object.assign({}, state, {
        fetchingReports: true
      });

    case `${types.FETCH_REPORTS}_FULFILLED`:
      return Object.assign({}, state, {
        reports: action.payload.data,
        fetchingReports: false,
        serverError: false
      });

    case `${types.FETCH_REPORTS}_REJECTED`:
      return Object.assign({}, state, {
        isRejected: true,
        error: 'Fetch Reports action Failed'
      });
    /*************************Fetch Reports action states END *****************************/

    /*case types.FETCHING_REPORT_FIELDS:
      return Object.assign({}, state, {
        fetchingReportFields: true
      }); */

    case `${types.FETCH_REPORT_FIELDS}_PENDING`:
      return Object.assign({}, state, {
        fetchingReportFields: true
      });

    case `${types.FETCH_REPORT_FIELDS}_REJECTED`:
      //debugger;
      return Object.assign({}, state, {
        isRejected: true,
        error: 'Fetch Reports fields action Failed'
      });

    case types.FETCH_REPORT_FIELDS_SUCCESS:
      return Object.assign({}, state, {
        fields: action.data.fields,
        reportName: action.data.name,
        reportDescription: action.data.description,
        fetchingReportFields: false,
        serverError: false,
        businessReportId: action.data.businessReportId,
        companyCode: action.data.companyCode,
        companyCodeName: action.data.companyCodeName,
        countryCode: action.data.countryCode,
        countryName: action.data.countryName,
      });

    case types.SET_BUSINESS_REPORT: {
      return Object.assign({}, state, {
        businessReport: action.data
      });
    }

    case types.SET_USER_REPORT: {
      return Object.assign({}, state, {
        reportId: action.data.reportId
      });
    }

    case types.SET_FILTERS: {
      return Object.assign({}, state, {
        filters: action.data
      });
    }

    case types.SET_REPORT_FILTERS: {
      return Object.assign({}, state, {
        reportFilters: action.data
        // TODO - sample mockup structrue
        // api need to be fixed, current patch the structure in report-edit/filter.js
        // [
        //   {
        //     id: 33,
        //     name: 'Expiry Date',
        //     type: 'DATE',
        //     isMandatory: false,
        //     value: {
        //       start: new Date(),
        //       end: new Date()
        //     },
        //     url: null,
        //     listText: null,
        //     listValue: null,
        //     options: [
        //       { value: '1', label: 'Last Week' },
        //       { value: '2', label: 'Last Month' },
        //       { value: '3', label: 'Last Quarter' }
        //     ],
        //     isRollingDate: false
        //   },
        //   {
        //     id: 35,
        //     name: 'Status',
        //     type: 'MULTISELECT',
        //     isMandatory: false,
        //     //TODO - value is required not null
        //     value: [],
        //     url: null,
        //     listText: null,
        //     listValue: null,
        //     options: [
        //       { label: 'Active', value: 'ACTIVE' },
        //       { label: 'Cancelled', value: 'CANCELLED' },
        //       { label: 'Planned', value: 'PLANNED' },
        //       { label: 'Running', value: 'RUNNING' },
        //       { label: 'Terminated', value: 'TERMINATED' }
        //     ],
        //     isRollingDate: false
        //   },
        //   {
        //     id: 36,
        //     name: 'Odometer',
        //     type: 'NUMERICRANGE',
        //     isMandatory: false,
        //     value: null,
        //     url: null,
        //     listText: null,
        //     listValue: null,
        //     options: {
        //       maxRange: 150,
        //       minRange: 1
        //     },
        //     value: {
        //       max: 120,
        //       min: 20
        //     },
        //     isRollingDate: false
        //   },
        //   {
        //     id: 50,
        //     name: 'LeaseCategory',
        //     type: 'SINGLESELECT',
        //     isMandatory: false,
        //     value: null,
        //     url: null,
        //     listText: null,
        //     listValue: null,
        //     options: [
        //       { label: 'Operating', value: 'Operating' },
        //       { label: 'Novated Finance', value: 'Novated Finance' },
        //       { label: 'Service Only', value: 'Service Only' },
        //       { label: 'Econolease', value: 'Econolease' }
        //     ],
        //     isRollingDate: false
        //   },
        //   {
        //     id: 51,
        //     name: 'Term',
        //     type: 'NUMERIC',
        //     isMandatory: false,
        //     value: null,
        //     url: null,
        //     listText: null,
        //     listValue: null,
        //     options: null,
        //     value: null,
        //     isRollingDate: false
        //   }
        // ]
      });
    }

    case types.SET_SCHEDULE: {
      return Object.assign({}, state, {
        schedule: action.data
      });
    }

    case types.SET_RECIPIENTS: {
      return Object.assign({}, state, {
        recipients: action.data
      });
    }

    case types.SET_SELECTED_FIELDS:
      return Object.assign({}, state, {
        selectedFields: action.data
      });

    case types.SET_DETAILS:
      return Object.assign({}, state, { ...action.data });

    /*************************Export Reports action states START ***************************/
    case `${types.EXPORT_REPORT}_PENDING`:
      return Object.assign({}, state, {
        exportingReport: true
      });

    case `${types.EXPORT_REPORT}_FULFILLED`:
      return Object.assign({}, state, {
        exportingReport: false
      });

    case `${types.EXPORT_REPORT}_REJECTED`:
      return Object.assign({}, state, {
        isRejected: true,
        error: 'export Reports action Failed'
      });
    /*************************Export Reports action states END ***************************/

    /*************************Export Customized Report action states START ***************************/
    case `${types.EXPORT_CUSTOMISED_REPORT}_PENDING`:
      return Object.assign({}, state, {
        exportingCustomisedReport: true
      });

    case `${types.EXPORT_CUSTOMISED_REPORT}_FULFILLED`:
      return Object.assign({}, state, {
        exportingCustomisedReport: false
      });

    case `${types.EXPORT_CUSTOMISED_REPORT}_REJECTED`:
      return Object.assign({}, state, {
        isRejected: true,
        error: 'Export customized report action Failed'
      });
    /*************************Export Customized Report action states END ***************************/

    /*************************Save Reports action states START ***************************/
    case `${types.SAVE_REPORT}_PENDING`:
      return Object.assign({}, state, {
        savingReport: true
      });

    case `${types.SAVE_REPORT}_FULFILLED`:
      return Object.assign({}, state, {
        savingReport: false,
        // after save report, reset dyanmicFilters restrictions
        dynamicFilters: []
      });

    case `${types.SAVE_REPORT}_REJECTED`:
      return {
        isRejected: true,
        error: 'Save Reports action Failed'
      };
    /*************************Save Reports action states END ***************************/

    /*************************DELETE Reports action states START ***************************/
    case `${types.DELETE_REPORT}_PENDING`:
      return Object.assign({}, state, {
        deletingReport: true
      });
    case `${types.DELETE_REPORT}_FULFILLED`:
      return Object.assign({}, state, {
        deletingReport: false
      });

    case `${types.DELETE_REPORT}_REJECTED`:
      return {
        isRejected: true,
        error: 'DELETE Reports action Failed'
      };
    /*************************DELETE Reports action states END ***************************/

    case types.SET_COUNTRY: {
      return Object.assign({}, state, {
        country: action.data
      });
    }

    case types.SET_COSTCENTER: {
      return Object.assign({}, state, {
        costcenter: action.data
      });
    }

    case types.RESET_RESTRICTIONS: {
      return Object.assign({}, state, {
        dynamicFilters: action.data
      });
    }

    case types.SET_RESTRICTIONS: {
      return Object.assign({}, state, {
        dynamicFilters: state.dynamicFilters.map(
          filter =>
            filter.typeId === action.data.typeId
              ? { ...filter, value: action.data.value }
              : filter
        )
      });
    }

    case types.CHANGE_SCHEDULE:
      return Object.assign({}, state, {
        isScheduleUpdated: true
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/reducers.js